import type { ComponentPropsWithoutRef } from 'react';
import useTranslation from 'next-translate/useTranslation';
import clsx from 'clsx';

import Icon from '@/components/base/Icon';

type QuoteBadgeProps = ComponentPropsWithoutRef<'span'> & {
    withText?: boolean;
    isExport?: boolean;
};
export const QuoteBadge = ({
    className,
    withText = true,
    isExport = false,
    ...restProps
}: QuoteBadgeProps) => {
    const { t } = useTranslation('commons');

    return (
        <span
            className={clsx(
                'inline-flex items-center space-x-1 rounded bg-icoAquaBlue-100 px-2 py-1 text-icoAquaBlue',
                { 'backdrop-blur-sm': !withText, 'dark:bg-icoAquaBlue/20': !isExport },
                className
            )}
            aria-label="quote-badge"
            {...restProps}>
            <Icon icon="quotes" />
            {withText ? <span aria-label="quote">{t('retweet_quote')}</span> : null}
        </span>
    );
};
